export type Step = 'init' | 'payment' | 'finish'
export type Action = 'default' | 'calendar' | 'camera' | 'summary'

export const getAmount = (selectedIndex: number, tiles?: payments.WarehouseRentalScheduleTile[]) => {
  let amount = 0
  if (tiles) {
    for (let i = 0; i < tiles.length; i++) {
      amount += Number(tiles[i].grossPrice)
      if (i === selectedIndex) break
    }
  }
  return amount
}

export const getTotalDeposits = (selectedData: payments.SelectedData, warehouse?: payments.CancelRentalResponseWarehouse) => {
  let deposit = 0
  if (warehouse?.itemsToReturn) {
    for (const item of warehouse.itemsToReturn) {
      if (selectedData.itemsToReturn?.[item.id]) {
        deposit += Number(item.deposit)
      }
    }
  }
  return deposit
}